export default function SidebarReducer(sidebar, action) {
  //console.log("sidebar", sidebar);
  //console.log("action", action);
  switch (action.type) {
    case "toggle":
      return { open: !sidebar.open };
    case "close":
      return { open: false };
    case "open":
      return { open: true };
    default:
      return sidebar;
  }
}
